var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1376 4.64296C12.5361 4.03027 11.8191 3.54283 11.0281 3.20879C10.2372 2.87476 9.38783 2.70074 8.52922 2.69679C7.67061 2.69285 6.81973 2.85905 6.02572 3.18581C5.2317 3.51256 4.5103 3.9934 3.90316 4.60053C3.29603 5.20767 2.8152 5.92907 2.48844 6.72309C2.16168 7.5171 1.99548 8.36798 1.99942 9.22659C2.00337 10.0852 2.17739 10.9345 2.51143 11.7255C2.84546 12.5165 3.3329 13.2334 3.94559 13.835C5.16835 15.0354 6.81568 15.7045 8.52922 15.6967C10.2428 15.6888 11.8839 15.0046 13.0956 13.7929C14.3072 12.5812 14.9914 10.9401 14.9993 9.22659C15.0072 7.51305 14.3381 5.86572 13.1376 4.64296ZM2.53159 3.22896C4.06441 1.69652 6.12475 0.807537 8.29127 0.743793C10.4578 0.680049 12.5668 1.44636 14.1871 2.88603C15.8074 4.3257 16.8165 6.32995 17.008 8.48894C17.1995 10.6479 16.5591 12.7985 15.2176 14.501L20.5626 19.846L19.1486 21.26L13.8036 15.915C12.1006 17.2515 9.95184 17.888 7.79565 17.6946C5.63946 17.5011 3.6383 16.4924 2.20037 14.8741C0.762442 13.2558 -0.00391081 11.1498 0.0576392 8.98586C0.119189 6.82189 1.004 4.76292 2.53159 3.22896Z",
    fill: "#1C4370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d60f2dd22113a4aeb67b335111fcecd2.svg";
export { ForwardRef as ReactComponent };